/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import { GraphQLList as List } from 'graphql';
import fetch from '../../core/fetch';
import PostType from '../types/PostType';

const url = 'http://agenceprolifik.ca/dev/wp-json/wp/v2/posts';

let items = [];

const posts = {
    type: new List(PostType),
    resolve() {
        
        return fetch(url)
        .then(res => {
            
            return res.json();
           
        })
        .then(data => {
           
            items = data;
            return items;

        });
    },
};

export default posts;



// WEBPACK FOOTER //
// ./data/queries/posts.js